import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {get} from "../../network/axiosServices";


const initialState = {
    loading: false,
    posts: [],
    error: '',
}

export const fetchFooter = createAsyncThunk("fetchFooter", (params) => {
    return get(params);
});


const postSlice = createSlice({
    name: 'footer',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchFooter.pending, (state) => {
            state.loading = true
            state.posts = []
            state.error = ''
        })
        builder.addCase(fetchFooter.fulfilled, (state, action) => {
            state.loading = false
            state.posts = action.payload
            state.error = ''
        })
        builder.addCase(fetchFooter.rejected, (state, action) => {
            state.loading = false
            state.posts = []
            state.error = action.error
        })

    }
})


export default postSlice.reducer
